import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { apiBaseUrl, apiRoots } from 'src/config';
import { TaskBase, TaskMapper } from './task-base.model';
import { TaskBaseApi } from './task-base.api';

export interface ToolingTaskInfo extends TaskBase {
  /**
   * The tooling this task is connected to.
   */
  toolingId: string;
  /**
   * Tooling needed.
   */
  toolingForRotor?: string;
  /**
   * ?
   */
  numberUses?: number;
  /**
   * ?
   */
  minNumberCompensationAveraging?: number;
  /**
   * ?
   */
  usedNumberCompensationAveraging?: number;
}

const baseUrl = apiBaseUrl + apiRoots.toolingTask;

@Injectable()
export class ToolingTaskApi extends TaskBaseApi<ToolingTaskInfo> {
  constructor() {
    const http = inject(HttpClient);

    super(http, baseUrl);
  }

  /**
   * Gets all tasks related to a tooling.
   */
  tasksByTooling$(toolingId: string) {
    return this.http
      .get<ToolingTaskInfo[]>(`${apiBaseUrl}${apiRoots.toolingOverview}/tasksbyasset/${toolingId}`)
      .pipe(map(tasks => tasks.map(task => TaskMapper.mapFromBackend<ToolingTaskInfo>(task))));
  }
}
